"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _temp;

var ForumCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(ForumCard, _Card$makeDefaultCard);

  function ForumCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ForumCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ForumCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "postCount", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ForumCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(ForumCard.prototype), "renderBottomContent", this).call(this);
      return _react.default.createElement("p", null, this.postCount, " ", _react.default.createElement("span", null, "post", this.postCount == 1 ? '' : 's'));
    }
  }]);
  return ForumCard;
}(_base.default.makeDefaultCardType('forum', 'Forum Post')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "postCount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ForumCard;